import { saveAs } from 'file-saver'
import { DisplayDate } from '../../services/DateTime'
import { ITrainerProfileEvent } from './ItemPersonDTO'

const CSV_COLUMNS = [
  'VeranstaltungsID',
  'Startdatum',
  'Enddatum',
  'Dauer (in Tagen)',
  'Veranstaltungsart',
  'Auftragsstatus',
  'Veranstaltungsname',
  'Veranstaltungskunde',
  'Land der Veranstaltung (Aus Venue)',
  'Land der Veranstaltung (Aus Kunde)',
  'Anzahl Teilnehmer',
  'Co-Trainer (Kommasepariert)',
]

function escapeCsvCell(value: string | number | null | undefined): string {
  const raw = value === null || value === undefined ? '' : `${value}`
  return `"${raw.replace(/"/g, '""')}"`
}

function formatCsvDate(iso: string): string {
  if (!iso) { return '' }
  return DisplayDate(new Date(iso))
}

export function buildTrainerProfileCsv(events: ITrainerProfileEvent[]): string {
  const lines = [CSV_COLUMNS.map(escapeCsvCell).join(';')]
  events.forEach((e) => {
    lines.push([
      e.uniqueEventId,
      formatCsvDate(e.startDate),
      formatCsvDate(e.endDate),
      e.durationDays ?? '',
      e.eventKind,
      e.contractState,
      e.name,
      e.customerName,
      e.country,
      e.customerCountry,
      e.participantCount,
      e.coTrainers,
    ].map(escapeCsvCell).join(';'))
  })
  return lines.join('\n')
}

export function trainerProfileCsvFilename(displayName: string, date = new Date()): string {
  const y = date.getFullYear()
  const m = `${date.getMonth() + 1}`.padStart(2, '0')
  const d = `${date.getDate()}`.padStart(2, '0')
  const name = (displayName || 'Trainer').trim().replace(/[\\/:*?"<>|]/g, '')
  return `${y}-${m}-${d}-${name}-Trainerprofil.csv`
}

export function downloadTrainerProfileCsv(events: ITrainerProfileEvent[], displayName: string) {
  const csv = buildTrainerProfileCsv(events)
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
  saveAs(blob, trainerProfileCsvFilename(displayName), { autoBom: true })
}
